(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section-reviews"] && !Shopify.designMode) return;
  try {
    
  const gridSlider= document.querySelector('.reviews--custom grid-slider');
  if(window.theme.touch && gridSlider) {
    window.theme.touch = false;
    gridSlider.init()
    window.theme.touch = true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-section-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('[data-autoplay-video]');

  if (!('IntersectionObserver' in window)) {
    videos.forEach(v => v.play());
    return;
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.5 });

  videos.forEach(video => observer.observe(video));
});

window.addEventListener('load', () => {
  document.querySelectorAll('.hero__video').forEach(video => {
    video.setAttribute('preload', 'metadata');
    video.play().catch(() => {});
  });
});


  } catch(e) { console.error(e); }
})();
})();
